import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom";
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import SpeechApp from "./SpeechApp";
import ElabApp from "./ElabApp";
import { SpeakUrl } from "./libs/env";
import { EXAMLAB_URL } from "./libs/env";

// Sentry.init({
//   dsn: "https://b73029933b5140bfbe505d67ecff95eb@o1271839.ingest.sentry.io/6464580",
//   integrations: [new BrowserTracing()],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });
if (window.location.pathname.includes(EXAMLAB_URL)) {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <ElabApp />
      </Router>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else if (window.location.pathname.includes(SpeakUrl)) {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <SpeechApp />
      </Router>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Router>
        <App />
      </Router>
    </React.StrictMode>,
    document.getElementById("root")
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
